import { render, staticRenderFns } from "./StockIQIframe.vue?vue&type=template&id=69c1266a"
import script from "./StockIQIframe.vue?vue&type=script&lang=js"
export * from "./StockIQIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports